import React from "react";
import { ClipboardCheck, FileSearch, SlidersHorizontal } from "lucide-react";
import Navbar from "../components/layout/Navbar";
import PlatformPageHero from "../components/platform/PlatformPageHero";
import EurostatSection from "../components/sections/home/EurostatSection";

const principles = [
  { Icon: FileSearch, title: "Documented methods", body: "Processing choices and assumptions can be described alongside each output." },
  { Icon: SlidersHorizontal, title: "Defined controls", body: "Privacy and quality rules can be configured for the operator and intended use." },
  { Icon: ClipboardCheck, title: "Checked outputs", body: "Validation checks are applied before aggregate data is made available." },
];

const StatisticalQualityPage = () => (
  <div className="min-h-screen bg-paper">
    <Navbar />
    <main className="pt-16">
      <PlatformPageHero
        eyebrow="Statistical quality"
        title="Mobility data prepared for statistical use"
        body="We are aligning our processing with Eurostat's reference pipeline for mobile network data, so each aggregate output can be documented and reviewed against a public method."
      />
      <EurostatSection />
      <section className="py-20 bg-paper">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-5">
          {principles.map(({ Icon, title, body }) => (
            <article key={title} className="border border-paper-300 rounded-xl p-7">
              <Icon size={21} className="text-brand-700 mb-10" />
              <h2 className="font-display text-xl font-semibold text-ink mb-3">{title}</h2>
              <p className="text-sm text-ink-muted leading-relaxed">{body}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  </div>
);

export default StatisticalQualityPage;
